import { skeletonPrefixCls, stepsPrefixCls } from "@/base/components/index";
import { createStyles } from "antd-style";

export const useOnboardingStyles = createStyles(({ token, css }: any) => ({
  section: css`
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
  `,
  body: css``,
  title: css`
    margin-bottom: 20px;
  `,
  welcomeIcon: css``,
  titleSelectField: css`
    min-width: 200px;
    margin: 0;
  `,
  titleSelectParagraph: css`
    max-width: 600px;
    float: right;
    text-align: right;
  `,
  titleText: css`
    font-weight: 400 !important;
  `,
  titleDescription: css`
    max-width: 800px;
  `,
  spinIcon: css``,
  progress: css``,
  collapseLabel: css`
    padding-right: 16px;
  `,
  collapseLabelIcon: css`
    position: relative;
  `,
  collapseLabelIconSuccess: css`
    position: absolute;
    bottom: -0.5em;
    right: -0.5em;
  `,
  collapseBody: css`
    .${stepsPrefixCls} {
      max-width: 716px;
    }

    ul {
      padding-left: 16px;
      margin: 0;
      margin-top: 12px;

      li {
        padding-block: 2px;
        &::marker {
          color: ${token.ColorFigmaProductaccentAccent0150};
          font-size: 16px;
        }
      }
    }
  `,
  collapseDescriptionData: css`
    margin-top: 16px;
  `,
  collapseDescriptionActions: css`
    margin-top: 12px;
  `,
  triangleIcon: css`
    font-size: 12px;
    position: relative;
    left: 10px;
    top: -8px;
    margin-right: 14px;
  `,
  skeletonContainer: css`
    padding-block: 32px;
  `,
  skeletonTitle: css`
    width: 300px;
    margin-bottom: 24px;
  `,
  skeletonItem: css`
    width: 100%;
    min-height: 80px;

    .${skeletonPrefixCls}-image {
      width: 100% !important;
    }
  `,
}));
